import { faMegaphone } from "@fortawesome/duotone-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip } from "@mui/material";
import { ChosenThemeContext } from "@ngt/forms/src";
import * as Sentry from "@sentry/react";
import { useContext, useEffect, useRef, useState } from "react";

const ToggleFeedbackButton = () => {
    const [feedback, setFeedback] = useState(() => Sentry.getFeedback());
    const chosenTheme = useContext(ChosenThemeContext);
    const buttonRef = useRef<HTMLButtonElement>(null);
    
    useEffect(() => {
        if (buttonRef.current) {
            const unsubscribe = feedback?.attachTo(
                buttonRef.current, 
                { 
                    colorScheme: chosenTheme === 'dark' ? 
                        'dark' : 
                        chosenTheme === 'light' ? 
                            'light' : 
                            'system' 
                }
            );
            return () => {
                unsubscribe?.()
            }
        }
    }, [buttonRef, chosenTheme])

    if (!feedback) {
        return null;
    }

    return (
        <Tooltip
            title="Report a Bug"
        >
            <IconButton
                aria-label="theme"
                color="inherit"
                ref={buttonRef}
            >
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
}
export default ToggleFeedbackButton;

